{
  "(optional)": "(optioneel)",
  "(required)": "(vereist)"
}